import _slicedToArray from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectSpread from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator/index.js";
// src/index.ts
import { z } from "zod";

var FetcherClient = /*#__PURE__*/function () {
  function FetcherClient(_options) {
    var _this = this;

    _classCallCheck(this, FetcherClient);

    _defineProperty(this, "ctxSchema", void 0);

    _defineProperty(this, "headersShape", void 0);

    _defineProperty(this, "getHeadersFromOptions", function (options) {
      var opts = typeof options === "function" ? options() : options;
      var headers = _this.headersShape && "headers" in opts ? z.object(_this.headersShape).parse(opts.headers) : void 0;
      return headers;
    });

    _defineProperty(this, "createGet", function (getHeaders) {
      var get = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, schema, options) {
          var _getHeaders;

          var response;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch(url, _objectSpread(_objectSpread({
                  referrerPolicy: "no-referrer"
                }, options), {}, {
                  headers: _objectSpread(_objectSpread({}, (_getHeaders = getHeaders()) !== null && _getHeaders !== void 0 ? _getHeaders : {}), options === null || options === void 0 ? void 0 : options.headers)
                }));

              case 2:
                response = _context.sent;
                _context.t0 = schema;
                _context.next = 6;
                return response.json();

              case 6:
                _context.t1 = _context.sent;
                _context.t2 = _context.t0.parse.call(_context.t0, _context.t1);
                _context.t3 = response;
                return _context.abrupt("return", {
                  data: _context.t2,
                  response: _context.t3
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));

        return function get(_x, _x2, _x3) {
          return _ref.apply(this, arguments);
        };
      }();

      return get;
    });

    _defineProperty(this, "createPost", function (getHeaders) {
      var post = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(url, schema, data, options) {
          var _getHeaders2;

          var response;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return fetch(url, _objectSpread(_objectSpread({
                  method: "POST",
                  cache: "no-cache",
                  referrerPolicy: "no-referrer",
                  body: JSON.stringify(data)
                }, options), {}, {
                  headers: _objectSpread(_objectSpread({
                    "Content-Type": "application/json; charset=UTF-8"
                  }, (_getHeaders2 = getHeaders()) !== null && _getHeaders2 !== void 0 ? _getHeaders2 : {}), options === null || options === void 0 ? void 0 : options.headers)
                }));

              case 2:
                response = _context2.sent;
                _context2.t0 = schema;
                _context2.next = 6;
                return response.json();

              case 6:
                _context2.t1 = _context2.sent;
                _context2.t2 = _context2.t0.parse.call(_context2.t0, _context2.t1);
                _context2.t3 = response;
                return _context2.abrupt("return", {
                  data: _context2.t2,
                  response: _context2.t3
                });

              case 10:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));

        return function post(_x4, _x5, _x6, _x7) {
          return _ref2.apply(this, arguments);
        };
      }();

      return post;
    });

    _defineProperty(this, "createPatch", function (getHeaders) {
      var patch = /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(url, schema, data, options) {
          var _getHeaders3;

          var response;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return fetch(url, _objectSpread(_objectSpread({
                  method: "PATCH",
                  cache: "no-cache",
                  referrerPolicy: "no-referrer",
                  body: JSON.stringify(data)
                }, options), {}, {
                  headers: _objectSpread(_objectSpread({
                    "Content-Type": "application/json; charset=UTF-8"
                  }, (_getHeaders3 = getHeaders()) !== null && _getHeaders3 !== void 0 ? _getHeaders3 : {}), options === null || options === void 0 ? void 0 : options.headers)
                }));

              case 2:
                response = _context3.sent;
                _context3.t0 = schema;
                _context3.next = 6;
                return response.json();

              case 6:
                _context3.t1 = _context3.sent;
                _context3.t2 = _context3.t0.parse.call(_context3.t0, _context3.t1);
                _context3.t3 = response;
                return _context3.abrupt("return", {
                  data: _context3.t2,
                  response: _context3.t3
                });

              case 10:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));

        return function patch(_x8, _x9, _x10, _x11) {
          return _ref3.apply(this, arguments);
        };
      }();

      return patch;
    });

    _defineProperty(this, "createPut", function (getHeaders) {
      var put = /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(url, schema, data, options) {
          var _getHeaders4;

          var response;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return fetch(url, _objectSpread(_objectSpread({
                  method: "PUT",
                  cache: "no-cache",
                  referrerPolicy: "no-referrer",
                  body: JSON.stringify(data)
                }, options), {}, {
                  headers: _objectSpread(_objectSpread({
                    "Content-Type": "application/json; charset=UTF-8"
                  }, (_getHeaders4 = getHeaders()) !== null && _getHeaders4 !== void 0 ? _getHeaders4 : {}), options === null || options === void 0 ? void 0 : options.headers)
                }));

              case 2:
                response = _context4.sent;
                _context4.t0 = schema;
                _context4.next = 6;
                return response.json();

              case 6:
                _context4.t1 = _context4.sent;
                _context4.t2 = _context4.t0.parse.call(_context4.t0, _context4.t1);
                _context4.t3 = response;
                return _context4.abrupt("return", {
                  data: _context4.t2,
                  response: _context4.t3
                });

              case 10:
              case "end":
                return _context4.stop();
            }
          }, _callee4);
        }));

        return function put(_x12, _x13, _x14, _x15) {
          return _ref4.apply(this, arguments);
        };
      }();

      return put;
    });

    _defineProperty(this, "createDelete", function (getHeaders) {
      var del = /*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(url, schema, data, options) {
          var _getHeaders5;

          var response;
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return fetch(url, _objectSpread(_objectSpread({
                  method: "DELETE",
                  cache: "no-cache",
                  referrerPolicy: "no-referrer",
                  body: JSON.stringify(data)
                }, options), {}, {
                  headers: _objectSpread(_objectSpread({
                    "Content-Type": "application/json; charset=UTF-8"
                  }, (_getHeaders5 = getHeaders()) !== null && _getHeaders5 !== void 0 ? _getHeaders5 : {}), options === null || options === void 0 ? void 0 : options.headers)
                }));

              case 2:
                response = _context5.sent;
                _context5.t0 = schema;
                _context5.next = 6;
                return response.json();

              case 6:
                _context5.t1 = _context5.sent;
                _context5.t2 = _context5.t0.parse.call(_context5.t0, _context5.t1);
                _context5.t3 = response;
                return _context5.abrupt("return", {
                  data: _context5.t2,
                  response: _context5.t3
                });

              case 10:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }));

        return function del(_x16, _x17, _x18, _x19) {
          return _ref5.apply(this, arguments);
        };
      }();

      return del;
    });

    this.ctxSchema = _options.ctx;

    if ("headers" in _options) {
      this.headersShape = _options.headers;
    }
  }

  return _createClass(FetcherClient, [{
    key: "fetcher",
    value: function fetcher(fetcherDefinition) {
      return fetcherDefinition;
    }
  }, {
    key: "combineFetchers",
    value: function combineFetchers(fetcherDefs) {
      var _this2 = this;

      return function (options) {
        var fetchers = Object.entries(fetcherDefs).reduce(function (acc, _ref6) {
          var _ref7 = _slicedToArray(_ref6, 2),
              key = _ref7[0],
              fetcher = _ref7[1];

          acc[key] = /*#__PURE__*/function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(input) {
              var opts, ctx, get, post, patch, put, del, fetcherOpts, result, _opts$postProcess;

              return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) switch (_context6.prev = _context6.next) {
                  case 0:
                    opts = typeof options === "function" ? options() : options;
                    ctx = _this2.ctxSchema.parse(opts.ctx);
                    get = _this2.createGet(function () {
                      return _this2.getHeadersFromOptions(options);
                    });
                    post = _this2.createPost(function () {
                      return _this2.getHeadersFromOptions(options);
                    });
                    patch = _this2.createPatch(function () {
                      return _this2.getHeadersFromOptions(options);
                    });
                    put = _this2.createPut(function () {
                      return _this2.getHeadersFromOptions(options);
                    });
                    del = _this2.createDelete(function () {
                      return _this2.getHeadersFromOptions(options);
                    });
                    fetcherOpts = {
                      ctx: ctx,
                      headers: _this2.getHeadersFromOptions(options),
                      get: get,
                      post: post,
                      patch: patch,
                      put: put,
                      delete: del
                    };
                    _context6.prev = 8;
                    _context6.next = 11;
                    return fetcher(fetcherOpts, input);

                  case 11:
                    result = _context6.sent;
                    return _context6.abrupt("return", result);

                  case 15:
                    _context6.prev = 15;
                    _context6.t0 = _context6["catch"](8);

                    if (!((_opts$postProcess = opts.postProcess) !== null && _opts$postProcess !== void 0 && _opts$postProcess.onError)) {
                      _context6.next = 19;
                      break;
                    }

                    return _context6.abrupt("return", opts.postProcess.onError({
                      options: fetcherOpts,
                      input: input,
                      error: _context6.t0,
                      fetcher: fetcher,
                      fetcherName: key
                    }));

                  case 19:
                    throw _context6.t0;

                  case 20:
                  case "end":
                    return _context6.stop();
                }
              }, _callee6, null, [[8, 15]]);
            }));

            return function (_x20) {
              return _ref8.apply(this, arguments);
            };
          }();

          return acc;
        }, {});
        return fetchers;
      };
    }
  }]);
}();

export { FetcherClient };